'use client';

import { FC, ReactNode } from 'react';

import { useContentfulLiveUpdates } from '@contentful/live-preview/react';

import { Carousel } from '@telialt/common-carousel/src';

import { HeroBannerType } from '../../models/Content';
import { getBlockId } from '../../utils/content';
import { BlockHeroBannerContainer } from './BlockHeroBanner.styles';
import { BlockHeroBannerContent } from './BlockHeroBannerContent';
import { transformHeroBanner } from './transformers';

type Props = {
    contentItems: HeroBannerType[];
    forcedH2Heading?: boolean;
    breadcrumbs?: ReactNode;
};

export const BlockHeroBanner: FC<Props> = ({ contentItems: initialContentItems, forcedH2Heading, breadcrumbs }) => {
    const contentItems = useContentfulLiveUpdates(initialContentItems);
    const transformedContentItems = contentItems.map(transformHeroBanner);
    const firstContentItem = contentItems?.[0];

    return (
        <BlockHeroBannerContainer
            data-section="Hero"
            $hasControls={transformedContentItems.length > 1}
            id={getBlockId(firstContentItem)}
        >
            <Carousel
                variant="full-width"
                slides={transformedContentItems.map((transformedContentItem, index) => (
                    <BlockHeroBannerContent
                        content={transformedContentItem}
                        breadcrumbs={breadcrumbs}
                        titleTag={index === 0 && !forcedH2Heading ? 'h1' : 'h2'}
                        itemIndex={index}
                        key={index}
                    />
                ))}
            />
        </BlockHeroBannerContainer>
    );
};
